import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { BreadcrumbService } from '@library/core/services';

import { ReportDetailsService } from '../report.details.service';

@Component({
   selector: 'lib-edit-report',
   template: `
   <lib-loading *ngIf="!loadedReport"></lib-loading>
   <ng-container *ngIf="loadedReport">
      <lib-reports-display action="edit" [report]="loadedReport"></lib-reports-display>
   </ng-container>`,
})
export class EditReportComponent implements OnInit {

   loadedReport: any;

   constructor(
      private route: ActivatedRoute,
      private router: Router,
      private report: ReportDetailsService,
      private breadcrumbs: BreadcrumbService,
      private snackbar: MatSnackBar,
   ) { }

   ngOnInit(): void {
      this.breadcrumbs.newCrumb({ label: 'Reports', path: '/report' });
      this.breadcrumbs.addCrumble( 'Edit' );

      this.route.params.subscribe( params => {
         if ( !params?.id ) {
            this.back();
         }

         this.report.load( params.id ).subscribe(
            report => this.loadedReport = report,
            () => this.back() );
      });
   }

   back() {
      this.snackbar.open( `Could not find report`, '', { duration: 5000, verticalPosition: 'bottom' });
      this.router.navigate([ 'report' ]);
   }
}
